



















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseUser from '@/components/compte/edit/EditBaseUser.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloUser } from '@/models/alo/AloUser'
import { AloUser } from '@/models/alo/AloUser'
import { formatDate } from '@/filters/formatDate'
import { ApiUserRole } from '@/enum/ApiUserRole'
import { ApiResultCode } from '@/enum/ApiResultCode'

@Component({
  name: 'EditMembre',    
  components:{EditBaseUser}
})
export default class EditMembre extends Vue {
      
  private user:AloUser = getDefaultAloUser()

  get roles(){
    const r = []
    if(this.isAdminPlateforme) r.push({libelle:"Admin plateforme",value:ApiUserRole.AdminPlateforme})
    r.push(...[      
      {libelle:"Admin piscine",value:ApiUserRole.AdminPiscine},      
      {libelle:"Famille",value:ApiUserRole.Famille},      
      {libelle:"Client",value:ApiUserRole.Client},      
      {libelle:"MNS",value:ApiUserRole.MNS},      
      {libelle:"Proprietaire piscine",value:ApiUserRole.ProprietairePiscine},
    ])
    return r
  }

  edit(item:AloUser) {        
    this.user = (this.$refs.baseEdit as EditBaseUser).edit(item)    
  }

  get dateBirth() {
    return formatDate(this.user.usrDatbirth,"YYYY-MM-DD") 
  }

  set dateBirth(newValue){
    this.user.usrDatbirth = newValue//formatDate(newValue,"DD/MM/YYYY")
  }
  

  get configuration(){
    return this.$store.myGetters.configuration
  }
  
  private get editorConfig(){
    return {...this.configuration.editorDefaultConfig,height:350}
  }  

  get isAdminPlateforme(){
    return this.$store.myGetters.isAdminPlateforme
  }
 
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
